module.exports = "\r\n<ng-container *ngFor=\"let errorText of errorList\" >\r\n  <div class=\"error-div\">\r\n    <div class=\"media\">\r\n      <img src=\"assets/images/icon-alert-error.svg\" class=\"icon-alert-error\">\r\n      <div class=\"media-body align-self-center\">\r\n        <p class=\"error-text\">\r\n          {{errorText}}\r\n        </p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</ng-container>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/buyback-form/main-section/tabs/alert/alert.component.html
// module id = ./src/app/buyback-form/main-section/tabs/alert/alert.component.html
// module chunks = main